function openTab(tabId, containerId) {
        const container = document.getElementById(containerId);
        if (!container) {
            console.error('Container with id ' + containerId + ' not found.');
            return;
        }

        const tabContents = container.getElementsByClassName('tab-content');
        for (let i = 0; i < tabContents.length; i++) {
            tabContents[i].style.display = 'none';
        }

        const tabs = container.getElementsByClassName('tab');
        for (let i = 0; i < tabs.length; i++) {
            tabs[i].classList.remove('active-tab');
        }

        const selectedTab = document.getElementById(tabId);
        if (!selectedTab) {
            console.error('Element with id ' + tabId + ' not found.');
            return;
        }

        selectedTab.style.display = 'block';

        const tabButton = container.querySelector('[data-tab="' + tabId + '"]');
        if (tabButton) {
            tabButton.classList.add('active-tab');
        }
    }
    openTab('tab1', 'container1');